import {Tour} from 'nextstepjs';

export const ONBOARDING_EXPRESS_ORDER_COMPLETION_KEY = 'EXPRESS_ORDER_ONBOARDING_COMPLETION';

interface IGetSteps {
    isMobile: boolean;
}

export const getSteps = (args: IGetSteps): Tour[] => {
    const {isMobile} = args;
    const resolution = isMobile ? 'MOBILE' : 'DESKTOP';
    const expressOrderSelector = `#EXPRESS_ORDER_TOOLTIP_${resolution}_BUTTON`;

    return [
        {
            tour: 'mainTour',
            steps: [
                {
                    title: 'Express Order Step DT - not for display purpose',
                    content: '',
                    selector: expressOrderSelector,
                    icon: undefined,
                    pointerRadius: 12,
                    pointerPadding: 0,
                },
            ],
        },
    ];
};
